import { useMemo, useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";
import { ChevronDown, Search } from "lucide-react";

const label = (s) => [s.store_id, s.sub_agent_name, s.address, s.city].filter(Boolean).join(" · ");

// Search + tick one, several or all stores. value = [] means all stores.
export const StoreMultiPick = ({ stores, value, onChange }) => {
  const [q, setQ] = useState("");
  const shown = useMemo(() => stores.filter((s) => !q || label(s).toLowerCase().includes(q.toLowerCase())), [stores, q]);
  const sel = new Set(value);
  const toggle = (t) => onChange(sel.has(t) ? value.filter((x) => x !== t) : [...value, t]);
  const text = !value.length ? "All stores" : value.length === 1 ? label(stores.find((s) => s.door_tsp === value[0]) || {}).split(" · ")[0] : `${value.length} stores`;
  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button variant="outline" size="sm" className="justify-between min-w-[160px]" data-testid="history-store-picker">{text}<ChevronDown className="w-4 h-4 ml-2" /></Button>
      </PopoverTrigger>
      <PopoverContent className="w-96 p-2" align="start">
        <div className="relative mb-2">
          <Search className="w-3.5 h-3.5 absolute left-2.5 top-2.5 text-slate-400" />
          <Input autoFocus value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search store ID, dealer, address…" className="h-8 pl-8 text-xs" data-testid="history-store-search" />
        </div>
        <div className="flex gap-2 mb-1 text-xs">
          <button type="button" className="text-teal hover:underline" onClick={() => onChange([])} data-testid="history-store-all">All stores</button>
          {q && <button type="button" className="text-teal hover:underline" onClick={() => onChange([...new Set([...value, ...shown.map((s) => s.door_tsp)])])} data-testid="history-store-select-shown">Select these {shown.length}</button>}
        </div>
        <div className="max-h-72 overflow-y-auto">
          {shown.map((s) => (
            <label key={s.door_tsp} className="flex items-center gap-2 px-1.5 py-1 rounded hover:bg-slate-50 text-xs cursor-pointer" data-testid={`history-store-opt-${s.door_tsp}`}>
              <Checkbox checked={sel.has(s.door_tsp)} onCheckedChange={() => toggle(s.door_tsp)} />
              <span className="truncate">{label(s)}</span>
            </label>
          ))}
          {!shown.length && <p className="text-xs text-slate-400 p-2">No stores match.</p>}
        </div>
      </PopoverContent>
    </Popover>
  );
};
